<ng-content></ng-content>
<div #viewport class="viewport mat-elevation-z8">
  <div #viewportPages class="viewport-pages">
    <div #viewportVisible id='visible' class="viewport-visible"></div>
  </div>
</div>
